import React, { useState } from "react";
import { Button, Form, Table } from "react-bootstrap";
import { CustomModal } from "../../components";
import axios from "axios";
import {
  useCreateRaffleMutation,
  useDeleteRaffleMutation,
  useFetchAllRafflesQuery,
  useUpdateRaffleMutation,
  s,
} from "../../store/api/apiSlice";
import { toast } from "react-toastify";
import { Button as CustomBtn } from "../../ui";
const RaffleSettings = () => {
  const {
    data: rafflesData = { raffles: [] },
    isLoading,
    refetch,
  } = useFetchAllRafflesQuery();
  const [createRaffle] = useCreateRaffleMutation();
  const [updateRaffle] = useUpdateRaffleMutation();
  const [deleteRaffle] = useDeleteRaffleMutation();
  const itemsPerPage = 10;
  const [currentPage, setCurrentPage] = useState(1);
  const [saveButton, setSaveButton] = useState(false);

  const [isModalOpen, setModalOpen] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [isViewModalOpen, setViewModalOpen] = useState(false);
  const [currentRaffle, setCurrentRaffle] = useState({
    logoFile: null,
    sponsorLogoImage: null,
    entryDate: "",
    entryCutOff: "",
    description: "",
    narrative: "",
    sponsorName: "",
    sponsorLink: "",
    notes: "",
    sponsorId: "",
    collegeId: "",
    adminName: "",
    adminEmail: "",
    adminPhone: "",
    title: "",
  });
  const [viewedRaffle, setViewedRaffle] = useState(null);

  const baseUrl = process.env.REACT_APP_SERVER_URL;

  const openModal = () => {
    setModalOpen(true);
  };
  const closeModal = () => {
    setModalOpen(false);
    setIsEditing(false);
    setCurrentRaffle({
      sponsorName: "",
      title: "",
      entryDate: "",
      entryCutOff: "",
      description: "",
      narrative: "",
      sponsorLink: "",
      notes: "",
      logoFile: null,
      sponsorLogoImage: null,
    });
  };
  const openViewModal = async (raffleId) => {
    try {
      const response = await fetch(
        `${baseUrl}/api/raffles/get-single/${raffleId}`,
        {
          headers: {
            "Content-Type": "application/json",
            "secret-key": process.env.REACT_APP_SECRET_KEY,
            "x-auth-token":
              JSON.parse(localStorage.getItem("token"))?.token || "",
          },
        }
      );
      if (response.ok) {
        const data = await response.json();
        setViewedRaffle(data.raffle);
        setViewModalOpen(true);
      } else {
      }
    } catch (error) {}
  };
  const closeViewModal = () => {
    setSaveButton(false);
    setViewModalOpen(false);
    setViewedRaffle(null);
  };

  const handleCreateOrUpdate = async (e) => {
    setSaveButton(true);
    e.preventDefault();

    try {
      const formData = new FormData();

      // Append all fields to formData
      formData.append("entryDate", currentRaffle.entryDate);
      formData.append("entryCutOff", currentRaffle.entryCutOff);
      formData.append("description", currentRaffle.description);
      formData.append("narrative", currentRaffle.narrative);
      formData.append("sponsorName", currentRaffle.sponsorName);
      formData.append("sponsorLink", currentRaffle.sponsorLink);
      formData.append("notes", currentRaffle.notes);
      formData.append("sponsorId", currentRaffle.sponsorId);
      formData.append("collegeId", currentRaffle.collegeId);
      formData.append("adminName", currentRaffle.adminName);
      formData.append("adminEmail", currentRaffle.adminEmail);
      formData.append("adminPhone", currentRaffle.adminPhone);
      formData.append("title", currentRaffle.title);

      // Append files if they exist
      if (currentRaffle.logoFile) {
        formData.append("logoFile", currentRaffle.logoFile);
      }
      if (currentRaffle.sponsorLogoImage) {
        formData.append("sponsorLogoImage", currentRaffle.sponsorLogoImage);
      }

      const token = JSON.parse(localStorage.getItem("token"))?.token || "";
      const secretKey = process.env.REACT_APP_SECRET_KEY;

      if (isEditing) {
        await axios.put(
          `${baseUrl}/api/raffles/update/${currentRaffle._id}`,
          formData,
          {
            headers: {
              "x-auth-token": token,
              "secret-key": secretKey,
              "Content-Type": "multipart/form-data",
            },
          }
        );
        setSaveButton(false);
        toast.success("Updated Successfully.");
      } else {
        await axios.post(`${baseUrl}/api/raffles/create`, formData, {
          headers: {
            "x-auth-token": token,
            "secret-key": secretKey,
            "Content-Type": "multipart/form-data",
          },
        });
        setSaveButton(false);
        toast.success("Created Successfully.");
      }

      closeModal();
      refetch();
    } catch (error) {
      setSaveButton(false);
      toast.error("Error");
      console.error("Error:", error);
    }
  };
  const handleEdit = (raffle) => {
    setCurrentRaffle({
      _id: raffle._id,
      entryDate: new Date(raffle.entryDate).toISOString().split("T")[0],
      entryCutOff: raffle.entryCutOff || "",
      description: raffle.description || "",
      narrative: raffle.narrative || "",
      sponsorName: raffle.sponsorName || "",
      sponsorLink: raffle.sponsorLink || "",
      notes: raffle.notes || "",
      logoFile: raffle.logoFile ? raffle.logoFile : null,
      sponsorLogoImage: raffle.sponsorLogoImage
        ? raffle.sponsorLogoImage
        : null,
      sponsorId: raffle.sponsorId || "",
      collegeId: raffle.collegeId || "",
      adminName: raffle.adminName || "",
      adminEmail: raffle.adminEmail || "",
      adminPhone: raffle.adminPhone || "",
      title: raffle.title || "",
    });
    setIsEditing(true);
    openModal();
  };
  const handleDelete = async (id) => {
    await deleteRaffle(id);
    refetch();
  };

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    if (files && files.length > 0) {
      setCurrentRaffle((prev) => ({
        ...prev,
        [name]: files[0],
      }));
    } else {
      setCurrentRaffle((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };
  const raffles = rafflesData.raffles || [];

  const sortedRaffles = [...raffles].sort(
    (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
  );

  const paginatedUsers = sortedRaffles.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );
  const totalPages = Math.ceil(sortedRaffles.length / itemsPerPage);
  if (isLoading) return <p>Loading...</p>;

  return (
    <div className="container">
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginTop: "22px",
        }}
      >
        <h3 className="mb-4">Sponsor Support Settings</h3>
        <Button variant="danger" className="mb-3" onClick={openModal}>
          Create Sponsor Support
        </Button>
      </div>

      <Table striped bordered hover responsive className="raffle-table">
        <thead>
          <tr>
            <th>Sponsor Name</th>
            <th>Title</th>
            <th>Entry Date</th>
            <th>Entry CutOff</th>
            <th>Description</th>
            <th>Narrative</th>
            <th>Sponsor Link</th>
            <th>Logo</th>
            <th>Sponsor Logo</th>
            <th>Notes</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {paginatedUsers.map((raffle) => (
            <tr
              key={raffle._id}
              onClick={() => openViewModal(raffle._id)}
              style={{ cursor: "pointer" }}
            >
              <td>{raffle.sponsorName}</td>
              <td>{raffle.title ? raffle.title : "N/A"}</td>
              <td>{new Date(raffle.entryDate).toISOString().split("T")[0]}</td>
              <td>{raffle.entryCutOff}</td>
              <td>{raffle.description}</td>
              <td>{raffle.narrative}</td>
              <td>
                <a
                  href={raffle.sponsorLink}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Link
                </a>
              </td>
              <td>
                {raffle.logoFile && (
                  <img
                    src={`${baseUrl}/${raffle.logoFile}`}
                    alt="Logo"
                    style={{
                      width: "50px",
                      height: "50px",
                      objectFit: "cover",
                    }}
                  />
                )}
              </td>
              <td>
                {raffle.sponsorLogoImage && (
                  <img
                    src={`${baseUrl}/${raffle.sponsorLogoImage}`}
                    alt="Sponsor Logo"
                    style={{
                      width: "50px",
                      height: "50px",
                      objectFit: "cover",
                    }}
                  />
                )}
              </td>
              <td>{raffle.notes}</td>
              <td>
                <div
                  style={{
                    display: "flex",
                    gap: "5px",
                    justifyContent: "center",
                  }}
                >
                  <img
                    className="Update-delete-icon"
                    onClick={(e) => {
                      e.stopPropagation();
                      handleEdit(raffle);
                    }}
                    width="30"
                    height="30"
                    src="https://img.icons8.com/ios-glyphs/30/create-new.png"
                    alt="create-new"
                  />

                  <img
                    className="Update-delete-icon"
                    onClick={(e) => {
                      e.stopPropagation();
                      handleDelete(raffle._id);
                    }}
                    width="30"
                    height="30"
                    src="https://img.icons8.com/ios-glyphs/30/filled-trash.png"
                    alt="filled-trash"
                  />
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
      <div className="d-flex justify-content-center mt-3">
        {Array.from({ length: totalPages }, (_, index) => (
          <Button
            key={index}
            variant={currentPage === index + 1 ? "primary" : "outline-primary"}
            onClick={() => setCurrentPage(index + 1)}
            className="mx-1"
          >
            {index + 1}
          </Button>
        ))}
      </div>

      <CustomModal
        isOpen={isModalOpen}
        onClose={closeModal}
        className="scrollable-modal"
      >
        <div style={{ padding: "1rem", maxHeight: "80vh", overflowY: "auto" }}>
          <h4
            style={{
              fontSize: "1.2rem",
              fontWeight: "bold",
              textAlign: "center",
              marginBottom: "20px",
            }}
          >
            {isEditing ? "Edit Sponsor Support" : "Create Sponsor Support"}
          </h4>
          <Form onSubmit={handleCreateOrUpdate}>
            <Form.Group style={{ marginBottom: "10px" }}>
              <Form.Label>Sponsor Name</Form.Label>
              <Form.Control
                name="sponsorName"
                value={currentRaffle.sponsorName}
                onChange={handleChange}
              />
            </Form.Group>
            <Form.Group style={{ marginBottom: "10px" }}>
              <Form.Label>Title</Form.Label>
              <Form.Control
                name="title"
                value={currentRaffle.title}
                onChange={handleChange}
              />
            </Form.Group>
            <Form.Group style={{ marginBottom: "10px" }}>
              <Form.Label>Entry Date</Form.Label>
              <Form.Control
                type="date"
                name="entryDate"
                value={currentRaffle.entryDate}
                onChange={handleChange}
              />
            </Form.Group>
            <Form.Group style={{ marginBottom: "10px" }}>
              <Form.Label>Entry CutOff</Form.Label>
              <Form.Control
                name="entryCutOff"
                value={currentRaffle.entryCutOff}
                onChange={handleChange}
              />
            </Form.Group>
            <Form.Group style={{ marginBottom: "10px" }}>
              <Form.Label>Description</Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                name="description"
                value={currentRaffle.description}
                onChange={handleChange}
              />
            </Form.Group>
            <Form.Group style={{ marginBottom: "10px" }}>
              <Form.Label>Narrative</Form.Label>
              <Form.Control
                name="narrative"
                value={currentRaffle.narrative}
                onChange={handleChange}
              />
            </Form.Group>
            <Form.Group style={{ marginBottom: "10px" }}>
              <Form.Label>Sponsor Link</Form.Label>
              <Form.Control
                name="sponsorLink"
                value={currentRaffle.sponsorLink}
                onChange={handleChange}
              />
            </Form.Group>
            <Form.Group style={{ marginBottom: "10px" }}>
              <Form.Label>Notes</Form.Label>
              <Form.Control
                name="notes"
                value={currentRaffle.notes}
                onChange={handleChange}
              />
            </Form.Group>
            <Form.Group style={{ marginBottom: "10px" }}>
              <Form.Label>Logo File</Form.Label>
              <Form.Control
                type="file"
                name="logoFile"
                onChange={handleChange}
              />
              {currentRaffle.logoFile &&
                typeof currentRaffle.logoFile === "string" && (
                  <img
                    src={`${baseUrl}/${currentRaffle.logoFile}`}
                    alt="Logo Preview"
                    style={{ width: "100px", marginTop: "10px" }}
                  />
                )}
            </Form.Group>
            <Form.Group style={{ marginBottom: "10px" }}>
              <Form.Label>Sponsor Logo Image</Form.Label>
              <Form.Control
                type="file"
                name="sponsorLogoImage"
                onChange={handleChange}
              />
              {currentRaffle.sponsorLogoImage &&
                typeof currentRaffle.sponsorLogoImage === "string" && (
                  <img
                    src={`${baseUrl}/${currentRaffle.sponsorLogoImage}`}
                    alt="Sponsor Logo Preview"
                    style={{ width: "100px", marginTop: "10px" }}
                  />
                )}
            </Form.Group>
            <div style={{ display: "flex", justifyContent: "flex-end" }}>
              <CustomBtn
                loading={saveButton}
                type="submit"
                variant="primary"
                style={{ padding: "12px", fontWeight: "bold" }}
              >
                {isEditing ? "Update" : "Create"}
              </CustomBtn>
            </div>
          </Form>
        </div>
      </CustomModal>

      <CustomModal isOpen={isViewModalOpen} onClose={closeViewModal}>
        <div
          style={{
            maxWidth: "600px",
            padding: "20px",
            maxHeight: "80vh",
            overflowY: "auto",
          }}
        >
          <h3>Raffle Details</h3>
          <p>
            <strong>Sponsor Name:</strong> {viewedRaffle?.sponsorName}
          </p>
          <p>
            <strong>Entry Date:</strong>
            {viewedRaffle?.entryDate}
          </p>
          <p>
            <strong>Entry CutOff:</strong> {viewedRaffle?.entryCutOff}
          </p>
          <p>
            <strong>Description:</strong> {viewedRaffle?.description}
          </p>
          <p>
            <strong>Narrative:</strong> {viewedRaffle?.narrative}
          </p>
          <p>
            <strong>Sponsor Link:</strong>{" "}
            <a
              href={viewedRaffle?.sponsorLink}
              target="_blank"
              rel="noopener noreferrer"
            >
              Link
            </a>
          </p>
          <p>
            <strong>Notes:</strong> {viewedRaffle?.notes}
          </p>
          {viewedRaffle?.logoFile && (
            <div className="mt-2">
              <p>
                <strong>Logo:</strong>
              </p>
              <img
                src={`${baseUrl}/${viewedRaffle.logoFile}`}
                alt="Logo"
                width="100"
              />
            </div>
          )}
          {viewedRaffle?.sponsorLogoImage && (
            <div className="mt-2">
              <p>
                <strong>Sponsor Logo:</strong>
              </p>
              <img
                src={viewedRaffle.sponsorLogoImage}
                alt="Sponsor Logo"
                width="100"
              />
            </div>
          )}
        </div>
      </CustomModal>
    </div>
  );
};

export default RaffleSettings;
